















import { defineComponent } from '@vue/composition-api'
import DataTreeElement from './DataTreeElement.vue'

export default defineComponent({
  name: 'DetailTree',
  components: {
    DataTreeElement
  },
  emits: ['selected-element'],
  props: {
    tree: {
      required: true
    }
  },
  setup(props, { emit }) {
    const handleLabelSelect = (element) => {
      emit('selected-element', element)
    }

    const removeSelected = () => {
      document
        .querySelectorAll('#tree-container .selected')
        .forEach(elem => elem.classList.remove('selected'))
    }

    return {
      handleLabelSelect,
      removeSelected
    }
  }
})
